export default "__VITE_ASSET__COBLrl4F__"